module.exports = {
  development: {
    baseUrl: "/client",
    // mockUrl: "http://106.53.14.160:8002",
    // mockUrl: "http://127.0.0.1:8000",
    mockUrl: "https://www.customerservice10.com",
    // mockUrl: "http://172.3.1.2:8081",
  },
  production: {
    baseUrl: "/client",
    mockUrl: "https://www.customerservice10.com",
  },
};
